import { application } from "./application"

// Import controllers
import AccordionController from "./accordion_controller"
import DiscChartController from "./disc_chart_controller"
import TabsController from "./tabs_controller"
import DropdownController from "./dropdown_controller"
import TeamVisualizationController from "./team_visualization_controller"
import HiringManagerProfileVisualizationController from "./hiring_manager/profile_visualization_controller"
import HiringManagerLeadershipStyleController from "./hiring_manager/leadership_style_controller"
import HiringManagerProfileComparisonController from "./hiring_manager/profile_comparison_controller"
import InterviewLiveAssistanceController from "./interview/live_assistance_controller"
import MobileMenuController from "./mobile_menu_controller"
import SkillsController from "./skills_controller"
import RoleDetailsController from "./role_details_controller"
import TagsController from "./tags_controller"
import DynamicFieldsController from "./dynamic_fields_controller"
import LinkJobDescriptionController from "./link_job_description_controller"
import JobDescriptionToggleController from "./job_description_toggle_controller"
import DictationController from "./dictation_controller"
import DocumentReviewController from "./document_review_controller"
import NotificationsController from "./notifications_controller"
import AdminUserFormController from "./admin_user_form_controller"

// Register controllers manually
application.register("accordion", AccordionController)
application.register("disc-chart", DiscChartController)
application.register("tabs", TabsController)
application.register("dropdown", DropdownController)
application.register("team-visualization", TeamVisualizationController)
application.register("hiring-manager-profile", HiringManagerProfileVisualizationController)
application.register("hiring-manager-leadership", HiringManagerLeadershipStyleController)
application.register("hiring-manager-comparison", HiringManagerProfileComparisonController)
application.register("interview--live-assistance", InterviewLiveAssistanceController)
application.register("mobile-menu", MobileMenuController)
application.register("skills", SkillsController)
application.register("role-details", RoleDetailsController)
application.register("tags", TagsController)
application.register("dynamic-fields", DynamicFieldsController)
application.register("link-job-description", LinkJobDescriptionController)
application.register("job-description-toggle", JobDescriptionToggleController)
application.register("dictation", DictationController)
application.register("document-review", DocumentReviewController)
application.register("notifications", NotificationsController)
application.register("admin-user-form", AdminUserFormController)
